import { render } from "./RoomInfo.vue?vue&type=template&id=bc31b5c4&ts=true"
import script from "./RoomInfo.vue?vue&type=script&lang=ts"
export * from "./RoomInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__